import React, {useRef, RefObject, useCallback} from 'react';
import {Card, Fab, makeStyles, Theme} from '@material-ui/core'
import Webcam, {WebcamProps} from 'react-webcam'
import Close from '@material-ui/icons/Close';
import CameraAlt from '@material-ui/icons/CameraAlt';
import SwitchCamera from '@material-ui/icons/SwitchCamera';
const useStyles=makeStyles((theme: Theme)=>({
  container:{
    position: "relative",
    
  },
  footerButtons: {
    position: "absolute",
    bottom: 16,
    left:0,
    right: 0,
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    zIndex: 10
  },
  centerFloatingButton:{
    marginLeft: "12px",
    marginRight: "12px"
  }
}))

const mobileVideoConstraits = {
  width: 220,
  height: 220,
};

interface MobileWebcamProps extends Partial<WebcamProps> {
  onCancel: ()=>void,
  handleOnCapture: (webcamRef: RefObject<Webcam>)=> void
}
const MobileWebcam: React.FC<MobileWebcamProps> = ({onCancel, handleOnCapture, ...rest}) => {
  const [facingMode, setFacingMode] = React.useState<"user" | "environment">("environment");
  
  const webcamRef = useRef(null)
  const {footerButtons, centerFloatingButton, container} = useStyles()

  const handleSwitchCamera = useCallback(()=>{
    setFacingMode(
      prevState =>
        prevState === "user"
          ? "environment"
          : "user"
    );
  }, [ setFacingMode])

  return <div className={container}>
    <Webcam
      ref={webcamRef}
      videoConstraints={{...mobileVideoConstraits, facingMode}}
      audio={false}
      screenshotFormat="image/jpeg"
      style={{
        width: "100%",
        height: "200px",
        objectFit: "fill"
      }}
      />

    <div className={footerButtons} >
        <Fab size={"small"} color="secondary" aria-label="cancel" onClick={onCancel}><Close fontSize={"large"}/></Fab>
        <Fab color="primary" aria-label="take-picture" onClick={()=>handleOnCapture(webcamRef)} className={centerFloatingButton}><CameraAlt fontSize={"large"}/></Fab>
        <Fab size={"small"} color="secondary" aria-label="switch-camera" onClick={handleSwitchCamera}><SwitchCamera  fontSize={"large"}/></Fab>
      </div>
  </div>;
}

export default MobileWebcam;